export default __webpack_public_path__ + "static/media/Square.848e6e37.svg";